module.exports = "<input class=\"gmc-form-control gmc-status-input\" ng-attr-id={{::$ctrl.inputId}} ng-model=$ctrl.value ng-model-options={allowInvalid:true} gmc-phone-validator=\"$ctrl.$attrs.type === 'tel'\" ng-attr-type=\"{{::$ctrl.$attrs.type || 'text'}}\" ng-change=$ctrl.onInputChange() ng-readonly=$ctrl.readonly ng-attr-placeholder={{::$ctrl.placeholder}}>";


//////////////////
// WEBPACK FOOTER
// ./app/shared/components/gmc-status-input-notlock/gmc-status-input-notlock.component.html
// module id = 534
// module chunks = 31